// 開発環境用 自治体用
export const firebaseConfig = {
  apiKey: "AIzaSyDlC5vn78oQaIb3CRwJNpfmXhIwa5cCxMw",
  authDomain: "event-support-488600.firebaseapp.com",
  projectId: "event-support-488600",
  storageBucket: "event-support-488600.firebasestorage.app",
  messagingSenderId: "191839803943",
  appId: "1:191839803943:web:279c7397da7acb7fe28c02",
  measurementId: "G-2TB0NSCDF9"
};